import {
	WrenchScrewdriverIcon,
	GlobeAltIcon,
	ChatBubbleLeftRightIcon,
	Cog6ToothIcon,
	UsersIcon,
	EnvelopeIcon,
	DocumentTextIcon,
	ServerStackIcon,
	ChartBarIcon,
	ChartPieIcon,
	TableCellsIcon,
	CalendarIcon,
	ClockIcon,
	BellIcon,
	MegaphoneIcon,
	CameraIcon,
	PhotoIcon,
	VideoCameraIcon,
	MusicalNoteIcon,
	MapPinIcon,
	MapIcon,
	BuildingOfficeIcon,
	BuildingOffice2Icon,
	HomeIcon,
	AcademicCapIcon,
	TrophyIcon,
	StarIcon,
	HeartIcon,
	HandThumbUpIcon,
	ShieldCheckIcon,
	ShieldExclamationIcon,
	LockClosedIcon,
	KeyIcon,
	CurrencyDollarIcon,
	BanknotesIcon,
	CreditCardIcon,
	ShoppingCartIcon,
	ShoppingBagIcon,
	GiftIcon,
	TagIcon,
	BookOpenIcon,
	BookmarkIcon,
	NewspaperIcon,
	PencilSquareIcon,
	DocumentDuplicateIcon,
	FolderIcon,
	FolderOpenIcon,
	ArchiveBoxIcon,
	InboxIcon,
	PaperAirplaneIcon,
	PhoneIcon,
	DevicePhoneMobileIcon,
	ComputerDesktopIcon,
	CommandLineIcon,
	CpuChipIcon,
	CircleStackIcon,
	CloudIcon,
	SignalIcon,
	WifiIcon,
	BoltIcon,
	FireIcon,
	SparklesIcon,
	LightBulbIcon,
	PuzzlePieceIcon,
	CubeIcon,
	SwatchIcon,
	PaintBrushIcon,
	ScissorsIcon,
	BeakerIcon,
	CalculatorIcon,
	ClipboardDocumentIcon,
	ClipboardDocumentListIcon,
	ListBulletIcon,
	QueueListIcon,
	RocketLaunchIcon,
	FlagIcon,
	LinkIcon,
	MagnifyingGlassIcon,
	FunnelIcon,
	AdjustmentsHorizontalIcon,
	ArrowTrendingUpIcon,
	PresentationChartBarIcon,
	UserGroupIcon,
	IdentificationIcon,
	TicketIcon,
	LifebuoyIcon,
	BugAntIcon,
	EyeIcon,
	HandRaisedIcon,
	MicrophoneIcon,
	SpeakerWaveIcon,
	PrinterIcon,
	QrCodeIcon,
	HashtagIcon,
	AtSymbolIcon
} from "@heroicons/react/24/outline";
import { ReactNode } from "react";

export const iconMap: Record<string, (className: string) => ReactNode> = {
	WrenchScrewdriverIcon: (c) => <WrenchScrewdriverIcon className={c} />,
	GlobeAltIcon: (c) => <GlobeAltIcon className={c} />,
	ChatBubbleLeftRightIcon: (c) => <ChatBubbleLeftRightIcon className={c} />,
	Cog6ToothIcon: (c) => <Cog6ToothIcon className={c} />,
	UsersIcon: (c) => <UsersIcon className={c} />,
	EnvelopeIcon: (c) => <EnvelopeIcon className={c} />,
	DocumentTextIcon: (c) => <DocumentTextIcon className={c} />,
	ServerStackIcon: (c) => <ServerStackIcon className={c} />,
	ChartBarIcon: (c) => <ChartBarIcon className={c} />,
	ChartPieIcon: (c) => <ChartPieIcon className={c} />,
	TableCellsIcon: (c) => <TableCellsIcon className={c} />,
	CalendarIcon: (c) => <CalendarIcon className={c} />,
	ClockIcon: (c) => <ClockIcon className={c} />,
	BellIcon: (c) => <BellIcon className={c} />,
	MegaphoneIcon: (c) => <MegaphoneIcon className={c} />,
	CameraIcon: (c) => <CameraIcon className={c} />,
	PhotoIcon: (c) => <PhotoIcon className={c} />,
	VideoCameraIcon: (c) => <VideoCameraIcon className={c} />,
	MusicalNoteIcon: (c) => <MusicalNoteIcon className={c} />,
	MapPinIcon: (c) => <MapPinIcon className={c} />,
	MapIcon: (c) => <MapIcon className={c} />,
	BuildingOfficeIcon: (c) => <BuildingOfficeIcon className={c} />,
	BuildingOffice2Icon: (c) => <BuildingOffice2Icon className={c} />,
	HomeIcon: (c) => <HomeIcon className={c} />,
	AcademicCapIcon: (c) => <AcademicCapIcon className={c} />,
	TrophyIcon: (c) => <TrophyIcon className={c} />,
	StarIcon: (c) => <StarIcon className={c} />,
	HeartIcon: (c) => <HeartIcon className={c} />,
	HandThumbUpIcon: (c) => <HandThumbUpIcon className={c} />,
	ShieldCheckIcon: (c) => <ShieldCheckIcon className={c} />,
	ShieldExclamationIcon: (c) => <ShieldExclamationIcon className={c} />,
	LockClosedIcon: (c) => <LockClosedIcon className={c} />,
	KeyIcon: (c) => <KeyIcon className={c} />,
	CurrencyDollarIcon: (c) => <CurrencyDollarIcon className={c} />,
	BanknotesIcon: (c) => <BanknotesIcon className={c} />,
	CreditCardIcon: (c) => <CreditCardIcon className={c} />,
	ShoppingCartIcon: (c) => <ShoppingCartIcon className={c} />,
	ShoppingBagIcon: (c) => <ShoppingBagIcon className={c} />,
	GiftIcon: (c) => <GiftIcon className={c} />,
	TagIcon: (c) => <TagIcon className={c} />,
	BookOpenIcon: (c) => <BookOpenIcon className={c} />,
	BookmarkIcon: (c) => <BookmarkIcon className={c} />,
	NewspaperIcon: (c) => <NewspaperIcon className={c} />,
	PencilSquareIcon: (c) => <PencilSquareIcon className={c} />,
	DocumentDuplicateIcon: (c) => <DocumentDuplicateIcon className={c} />,
	FolderIcon: (c) => <FolderIcon className={c} />,
	FolderOpenIcon: (c) => <FolderOpenIcon className={c} />,
	ArchiveBoxIcon: (c) => <ArchiveBoxIcon className={c} />,
	InboxIcon: (c) => <InboxIcon className={c} />,
	PaperAirplaneIcon: (c) => <PaperAirplaneIcon className={c} />,
	PhoneIcon: (c) => <PhoneIcon className={c} />,
	DevicePhoneMobileIcon: (c) => <DevicePhoneMobileIcon className={c} />,
	ComputerDesktopIcon: (c) => <ComputerDesktopIcon className={c} />,
	CommandLineIcon: (c) => <CommandLineIcon className={c} />,
	CpuChipIcon: (c) => <CpuChipIcon className={c} />,
	CircleStackIcon: (c) => <CircleStackIcon className={c} />,
	CloudIcon: (c) => <CloudIcon className={c} />,
	SignalIcon: (c) => <SignalIcon className={c} />,
	WifiIcon: (c) => <WifiIcon className={c} />,
	BoltIcon: (c) => <BoltIcon className={c} />,
	FireIcon: (c) => <FireIcon className={c} />,
	SparklesIcon: (c) => <SparklesIcon className={c} />,
	LightBulbIcon: (c) => <LightBulbIcon className={c} />,
	PuzzlePieceIcon: (c) => <PuzzlePieceIcon className={c} />,
	CubeIcon: (c) => <CubeIcon className={c} />,
	SwatchIcon: (c) => <SwatchIcon className={c} />,
	PaintBrushIcon: (c) => <PaintBrushIcon className={c} />,
	ScissorsIcon: (c) => <ScissorsIcon className={c} />,
	BeakerIcon: (c) => <BeakerIcon className={c} />,
	CalculatorIcon: (c) => <CalculatorIcon className={c} />,
	ClipboardDocumentIcon: (c) => <ClipboardDocumentIcon className={c} />,
	ClipboardDocumentListIcon: (c) => <ClipboardDocumentListIcon className={c} />,
	ListBulletIcon: (c) => <ListBulletIcon className={c} />,
	QueueListIcon: (c) => <QueueListIcon className={c} />,
	RocketLaunchIcon: (c) => <RocketLaunchIcon className={c} />,
	FlagIcon: (c) => <FlagIcon className={c} />,
	LinkIcon: (c) => <LinkIcon className={c} />,
	MagnifyingGlassIcon: (c) => <MagnifyingGlassIcon className={c} />,
	FunnelIcon: (c) => <FunnelIcon className={c} />,
	AdjustmentsHorizontalIcon: (c) => <AdjustmentsHorizontalIcon className={c} />,
	ArrowTrendingUpIcon: (c) => <ArrowTrendingUpIcon className={c} />,
	PresentationChartBarIcon: (c) => <PresentationChartBarIcon className={c} />,
	UserGroupIcon: (c) => <UserGroupIcon className={c} />,
	IdentificationIcon: (c) => <IdentificationIcon className={c} />,
	TicketIcon: (c) => <TicketIcon className={c} />,
	LifebuoyIcon: (c) => <LifebuoyIcon className={c} />,
	BugAntIcon: (c) => <BugAntIcon className={c} />,
	EyeIcon: (c) => <EyeIcon className={c} />,
	HandRaisedIcon: (c) => <HandRaisedIcon className={c} />,
	MicrophoneIcon: (c) => <MicrophoneIcon className={c} />,
	SpeakerWaveIcon: (c) => <SpeakerWaveIcon className={c} />,
	PrinterIcon: (c) => <PrinterIcon className={c} />,
	QrCodeIcon: (c) => <QrCodeIcon className={c} />,
	HashtagIcon: (c) => <HashtagIcon className={c} />,
	AtSymbolIcon: (c) => <AtSymbolIcon className={c} />
};

// Friendly display names for the icon picker
export const iconDisplayNames: Record<string, string> = {
	WrenchScrewdriverIcon: "Wrench",
	GlobeAltIcon: "Globe",
	ChatBubbleLeftRightIcon: "Chat",
	Cog6ToothIcon: "Settings",
	UsersIcon: "Users",
	EnvelopeIcon: "Email",
	DocumentTextIcon: "Document",
	ServerStackIcon: "Server",
	ChartBarIcon: "Bar Chart",
	ChartPieIcon: "Pie Chart",
	TableCellsIcon: "Table",
	CalendarIcon: "Calendar",
	ClockIcon: "Clock",
	BellIcon: "Bell",
	MegaphoneIcon: "Megaphone",
	CameraIcon: "Camera",
	PhotoIcon: "Photo",
	VideoCameraIcon: "Video",
	MusicalNoteIcon: "Music",
	MapPinIcon: "Map Pin",
	MapIcon: "Map",
	BuildingOfficeIcon: "Building",
	BuildingOffice2Icon: "Office",
	HomeIcon: "Home",
	AcademicCapIcon: "Academic",
	TrophyIcon: "Trophy",
	StarIcon: "Star",
	HeartIcon: "Heart",
	HandThumbUpIcon: "Thumbs Up",
	ShieldCheckIcon: "Shield",
	ShieldExclamationIcon: "Shield Alert",
	LockClosedIcon: "Lock",
	KeyIcon: "Key",
	CurrencyDollarIcon: "Dollar",
	BanknotesIcon: "Money",
	CreditCardIcon: "Credit Card",
	ShoppingCartIcon: "Cart",
	ShoppingBagIcon: "Shopping",
	GiftIcon: "Gift",
	TagIcon: "Tag",
	BookOpenIcon: "Book",
	BookmarkIcon: "Bookmark",
	NewspaperIcon: "News",
	PencilSquareIcon: "Edit",
	DocumentDuplicateIcon: "Copy",
	FolderIcon: "Folder",
	FolderOpenIcon: "Open Folder",
	ArchiveBoxIcon: "Archive",
	InboxIcon: "Inbox",
	PaperAirplaneIcon: "Send",
	PhoneIcon: "Phone",
	DevicePhoneMobileIcon: "Mobile",
	ComputerDesktopIcon: "Desktop",
	CommandLineIcon: "Terminal",
	CpuChipIcon: "CPU",
	CircleStackIcon: "Database",
	CloudIcon: "Cloud",
	SignalIcon: "Signal",
	WifiIcon: "WiFi",
	BoltIcon: "Bolt",
	FireIcon: "Fire",
	SparklesIcon: "Sparkles",
	LightBulbIcon: "Light Bulb",
	PuzzlePieceIcon: "Puzzle",
	CubeIcon: "Cube",
	SwatchIcon: "Swatch",
	PaintBrushIcon: "Paint",
	ScissorsIcon: "Scissors",
	BeakerIcon: "Beaker",
	CalculatorIcon: "Calculator",
	ClipboardDocumentIcon: "Clipboard",
	ClipboardDocumentListIcon: "Checklist",
	ListBulletIcon: "List",
	QueueListIcon: "Queue",
	RocketLaunchIcon: "Rocket",
	FlagIcon: "Flag",
	LinkIcon: "Link",
	MagnifyingGlassIcon: "Search",
	FunnelIcon: "Filter",
	AdjustmentsHorizontalIcon: "Adjustments",
	ArrowTrendingUpIcon: "Trending",
	PresentationChartBarIcon: "Presentation",
	UserGroupIcon: "Group",
	IdentificationIcon: "ID Card",
	TicketIcon: "Ticket",
	LifebuoyIcon: "Support",
	BugAntIcon: "Bug",
	EyeIcon: "Eye",
	HandRaisedIcon: "Hand",
	MicrophoneIcon: "Microphone",
	SpeakerWaveIcon: "Speaker",
	PrinterIcon: "Printer",
	QrCodeIcon: "QR Code",
	HashtagIcon: "Hashtag",
	AtSymbolIcon: "At Symbol"
};

export const iconNames = Object.keys(iconMap);

export function getIcon(name: string, className: string = "w-5 h-5 lg:w-6 lg:h-6"): ReactNode {
	const factory = iconMap[name];
	if (factory) return factory(className);
	return iconMap["WrenchScrewdriverIcon"](className);
}
